import { getAccountSettings, updateAccountSettings, getAdminAccountSettings, updateAdminAccountSettings } from "../types/account_settings_types";


export const getAccountSettingsRequest = (req, cb) => ({
    type: getAccountSettings.REQUEST,
    payload: req,
    cb
})
export const getAccountSettingsSuccess = (res) => ({
    type: getAccountSettings.SUCCESS,
    payload: res
});
export const getAccountSettingsFailure = (error) => ({
    type: getAccountSettings.FAILURE,
    payload: error
});

export const updateAccountSettingsRequest = (req, cb) => ({
    type: updateAccountSettings.REQUEST,
    payload: req,
    cb
})
export const updateAccountSettingsSuccess = (res) => ({
    type: updateAccountSettings.SUCCESS,
    payload: res
});
export const updateAccountSettingsFailure = (error) => ({
    type: updateAccountSettings.FAILURE,
    payload: error
});

export const getAdminAccountSettingsRequest = (req, cb) => ({
    type: getAdminAccountSettings.REQUEST,
    payload: req,
    cb
})
export const getAdminAccountSettingsSuccess = (res) => ({
    type: getAdminAccountSettings.SUCCESS,
    payload: res
});
export const getAdminAccountSettingsFailure = (error) => ({
    type: getAdminAccountSettings.FAILURE,
    payload: error
});

export const updateAdminAccountSettingsRequest = (req, cb) => ({
    type: updateAdminAccountSettings.REQUEST,
    payload: req,
    cb
})
export const updateAdminAccountSettingsSuccess = (res) => ({
    type: updateAdminAccountSettings.SUCCESS,
    payload: res
});
export const updateAdminAccountSettingsFailure = (error) => ({
    type: updateAdminAccountSettings.FAILURE,
    payload: error
});